import { html } from 'lit';
import type { LandingLocale } from '../../shared/content/landingContent.js';

interface LanguageToggleOptions {
  currentLocale: LandingLocale;
  onChange: (locale: LandingLocale) => void;
}

export const languageToggle = ({ currentLocale, onChange }: LanguageToggleOptions) => {
  const flagCode: Record<LandingLocale, string> = { de: 'de', tr: 'tr', en: 'gb' };

  const option = (locale: LandingLocale, label: string) => html`
    <button
      type="button"
      class="vp-lang-option ${currentLocale === locale ? 'is-active' : ''}"
      aria-pressed=${currentLocale === locale}
      @click=${() => onChange(locale)}
    >
      <span class="vp-lang-flag fi fi-${flagCode[locale]}" aria-hidden="true"></span>
      <span>${label}</span>
    </button>
  `;
  const ariaLabel =
    currentLocale === 'tr' ? 'Dil seçimi' : currentLocale === 'en' ? 'Language switcher' : 'Sprachauswahl';

  return html`
    <div class="vp-lang-toggle" aria-label=${ariaLabel}>
      ${option('de', 'DE')} ${option('tr', 'TR')} ${option('en', 'EN')}
    </div>
  `;
};
